import InputTypes from '../../../core/enums/InputTypes';

export const inputsVinculos = [
    {
        name: 'instrumento',
        label: 'Instrumento',
        form: { use: true, validate: { required: true } },
    },
    { name: 'instrumentoView', label: 'Instrumento', table: { use: true } },
    { name: 'exercicio', label: 'Exercício', form: { use: true, validate: { required: true } } },
    { name: 'exercicioView', label: 'Exercício', table: { use: true } },
    {
        name: 'codigo',
        label: 'Código',
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'descricao',
        label: 'Descrição',
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
];

export const inputsDadosGerais = [
    {
        name: 'idProposta',
        label: 'ID Proposta',
        type: InputTypes.INTEGER,
    },
    {
        name: 'situacao',
        label: 'Situação',
        type: InputTypes.ENTITY,
        filter: { use: true, nameUse: 'situacaoProposta.id' },
    },
    {
        name: 'numeroProposta',
        label: 'Nº da Proposta',
        type: InputTypes.INTEGER,
        table: { use: true, nameUse: 'id' },
        filter: { use: true, nameUse: 'id' },
    },
    {
        name: 'tipoPropostaTable',
        label: 'Tipo de Proposta',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'tipoProposta.descTipoProposta' },
        export: { use: true, nameUse: 'tipoProposta.descTipoProposta' },
    },
    {
        name: 'tipoProposta',
        label: 'Tipo de Proposta',
        type: InputTypes.ENTITY,
    },
    {
        name: 'numrVersao',
        label: 'Versão',
        type: InputTypes.DOUBLE,
        table: { use: true },
        export: { use: true },
    },
    {
        name: 'nmIndicador',
        label: 'Nome do Indicador',
        type: InputTypes.STRING,
        table: { use: true },
        export: { use: true },
        form: { use: true, validate: { required: true, max: 100 } },
        filter: { use: true },
    },
    {
        name: 'tipoIndicador',
        label: 'Tipo de Indicador',
        type: InputTypes.ENTITY,
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'tipoIndicador.id' },
    },
    {
        name: 'tipoIndicadorTable',
        label: 'Tipo de Indicador',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'tipoIndicador.descTipoIndicador' },
        export: { use: true, nameUse: 'tipoIndicador.descTipoIndicador' },
    },
    {
        name: 'orgao',
        label: 'Órgão/Entidade',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'orgao.descOrgao' },
        export: { use: true, nameUse: 'orgao.descOrgao' },
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'orgao.idenOrgao' },
    },
    {
        name: 'unidadeOrcamentaria',
        label: 'UO: Unidade Orçamentária',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'unidadeOrcamentaria.descricaoUnidadeOrcamentaria' },
        export: { use: true, nameUse: 'unidadeOrcamentaria.descricaoUnidadeOrcamentaria' },
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'unidadeOrcamentaria.idenUo' },
    },
    {
        name: 'responsavelIndicador',
        label: 'Responsável do Indicador',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'responsavel.nomePessoa' },
        export: { use: true, nameUse: 'responsavel.nomePessoa' },
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'responsavel.nomePessoa', useLike: true },
    },
    {
        name: 'usuarioCadastro',
        label: 'Usuário de Cadastro',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
        form: { use: true },
        filter: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'desdobramento',
        label: 'Desdobramento',
        type: InputTypes.ENTITY,
        form: { use: true, validate: { required: true } },
        filter: { use: true, nameUse: 'subtipoIndicador.id' },
    },
    {
        name: 'descArea',
        label: 'Área',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true, max: 50 } },
    },
    {
        name: 'descSubArea',
        label: 'Subárea',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true, max: 50 } },
    },
    {
        name: 'descJustificativa',
        label: 'Justificativa',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true, max: 500 } },
    },
    {
        name: 'descObjetivo',
        label: 'Objetivo',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true, max: 300 } },
    },
    {
        name: 'situacaoPropostaView',
        label: 'Situação',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'situacaoProposta.descSituacao' },
        export: { use: true, nameUse: 'situacaoProposta.descSituacao' },
    },
];

export const inputsDadosComplementares = [
    {
        name: 'unidadeMedida',
        label: 'Unidade de Medida',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'descMetodologia',
        label: 'Metodologia de Cálculo',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true, max: 300 } },
    },
    {
        name: 'arquivoMetodologiaCalculo',
        label: 'Arquivo da Metodologia de Cálculo',
        type: InputTypes.FILE,
        table: { use: true },
        form: { use: true, validate: { required: false } },
    },
    {
        name: 'descInterpretacaoUso',
        label: 'Descrição / Interpretação e Uso',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true, max: 500 } },
    },
    {
        name: 'fontes',
        label: 'Fonte (s)',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true, max: 200 } },
    },
    {
        name: 'descPesquisaDados',
        label: 'Pesquisa e/ou Base de Dados',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true, max: 200 } },
    },
    {
        name: 'periodicidadeIndicador',
        label: 'Periodicidadee do indicador',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'desagregacaoGeografica',
        label: 'Desagregação Geográfica',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'desagregacaoCategorica',
        label: 'Desagregação Categórica',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'descInformacaoComplementar',
        label: 'Informações Complementares',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: false, max: 500 } },
    },
    {
        name: 'descLimitacao',
        label: 'Limitação',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true, max: 200 } },
    },
    {
        name: 'descRecomendacao',
        label: 'Recomendação',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: false, max: 500 } },
    },
    {
        name: 'compreensaoResultado',
        label: 'Compreensão do resultado do indicador',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'descParametroComparacao',
        label: 'Parâmetro e/ou Comparação',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: false, max: 200 } },
    },
    {
        name: 'restricaoPublicacaoDados',
        label: 'Existe restrição a publicação dos dados do indicador?',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'restricaoPublicacaoExcetoOrgao',
        label: 'Existe alguma restrição a publicação dos dados do indicador, exceto para utilização dos órgãos públicos?',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'restricaoPublicacaoExcetoUso',
        label: 'Existe alguma restrição a publicação dos dados do indicador, exceto para utilização dos dados do indicador?',
        type: InputTypes.ENTITY,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
];

export const inputsSerieHistoricaTopo = [
    {
        name: 'tipoCadastroProposta',
        type: InputTypes.ENTITY,
        label: 'Indicador Novo ou Existente',
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'concordaTermo',
        label: 'Concordo Com os Termos',
        type: InputTypes.BOOLEAN,
        form: { use: true, validate: { required: false } },
    },
];

export const inputsSerieHistorica = [
    {
        name: 'dataReferencia',
        label: 'Data de Referência:',
        type: InputTypes.DATE,
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'dataApuracao',
        label: 'Data de Apuração:',
        type: InputTypes.DATE,
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'valorApurado',
        label: 'Valor Apurado:',
        type: InputTypes.STRING,
        form: { use: true, validate: { required: true } },
    },
];
